<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps(["data"])

// Extract IP string from data (handle various formats)
const ipString = computed(() => {
  if (!props.data) return null

  // If data is an array, get the first item's IP
  if (Array.isArray(props.data)) {
    return props.data[0]?.ip || props.data[0]
  }

  // If data is an object with ip property
  if (typeof props.data === 'object' && props.data.ip) {
    return props.data.ip
  }

  // Otherwise assume it's already a string
  return props.data
})

// Extract country code if available
const countryCode = computed(() => {
  if (!props.data) return null

  // If data is an array, get the first item's country
  if (Array.isArray(props.data)) {
    return props.data[0]?.country
  }

  // If data is an object with country property
  if (typeof props.data === 'object' && props.data.country) {
    return props.data.country
  }

  return null
})
</script>

<template>
  <div v-if="ipString" class="d-flex vertically-centered">
    <img
      v-if="countryCode"
      height="13"
      style="border-radius: var(--radius-sm); display: block;"
      :src="require('@/assets/flags/4x3/' + countryCode.toLowerCase() + '.svg')"
    >
    <span :class="{'ps-1': countryCode}">{{ ipString }}</span>
  </div>
</template>

<style scoped>
.ip-container {
  position: relative;
}
</style>
